import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';

@Injectable()
export class EditAllowedIpEffects {
   constructor(
      private actions$: Actions,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private router: Router
   ) {}
}
